// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import { AddPost } from '@actions/posts';
import { ClearFeed, SetFeed } from '@actions/feed';

// Extend Array prototype for only method (declared elsewhere in the project)
declare global {
  interface Array<T> {
    only(property: string): string[];
  }
}

interface FeedState {
  loading: boolean;
  cacheKey?: string | null;
  hasNext?: boolean;
  posts: string[];
}

interface FeedNetworksState {
  twitter: FeedState;
  facebook: FeedState;
  instagram: FeedState;
  all: FeedState;
  [key: string]: FeedState;
}

interface Post {
  _id: string;
  [key: string]: unknown;
}

interface SetFeedPayload {
  network: string;
  posts: Post[];
  cacheKey?: string;
  hasNext?: boolean;
}

interface AddPostPayload {
  accountId: string;
  post: Post;
}

type SetFeedAction = Action<SetFeedPayload>;
type AddPostAction = Action<AddPostPayload>;

const initialFeedState: FeedState = {
  loading: true,
  cacheKey: null,
  hasNext: false,
  posts: [],
};

const initialState: FeedNetworksState = {
  twitter: initialFeedState,
  facebook: initialFeedState,
  instagram: initialFeedState,
  all: initialFeedState,
};

export default handleActions<
  FeedNetworksState,
  SetFeedPayload | AddPostPayload | void
>(
  {
    [SetFeed.toString()]: (
      state: FeedNetworksState,
      { payload }: SetFeedAction,
    ): FeedNetworksState => {
      const { network, ...rest } = payload;
      return {
        ...state,
        [network]: {
          ...rest,
          loading: false,
          posts: rest.posts.only('_id'),
        },
      };
    },
    [AddPost.toString()]: (
      state: FeedNetworksState,
      { payload }: AddPostAction,
    ): FeedNetworksState => {
      const { accountId, post } = payload;
      return {
        ...state,
        [accountId]: {
          ...state[accountId],
          posts: [
            post._id,
            ...(state[accountId] ? state[accountId].posts : []),
          ],
        },
        all: {
          ...state.all,
          posts: [post._id, ...state.all.posts],
        },
      };
    },
    [ClearFeed.toString()]: (): FeedNetworksState => {
      return initialState;
    },
  },
  initialState,
);
